// extracted by mini-css-extract-plugin
module.exports = {"filterTabs":"_18478","tabsContainer":"_14165","item":"_6056","text":"_8854","indicators":"_9029","indicator":"_6392","selected":"_4820","active":"_9998"};